import {
  Box,
  Card,
  Chip,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import {
  Edit,
  Visibility,
  AttachFile,
  ChatBubbleOutline,
  AccessTime,
} from "@mui/icons-material";
import { getEvidenceType } from "../../../common/EntitiesManagement";
import localize from "../../../common/localize";

export default function ReviewCard({ review, showEditNote }) {
  const formattedDate = review.CreationDate
    ? new Date(review.CreationDate).toLocaleString(undefined, {
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      })
    : null;

  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: 2,
        borderLeft: "4px solid",
        borderLeftColor: "primary.main",
        transition: "box-shadow 0.2s ease",
        "&:hover": {
          boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
        },
        overflow: "visible",
      }}
    >
      <Box sx={{ px: 2, py: 1.5 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            gap: 1,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, minWidth: 0 }}>
            <ChatBubbleOutline sx={{ fontSize: 16, color: "primary.main", flexShrink: 0, mt: 0.25 }} />
            <Typography variant="subtitle2" fontWeight={700} sx={{ lineHeight: 1.3 }}>
              {review.Title}
            </Typography>
          </Box>

          {showEditNote && (
            <Tooltip title={localize.edit} arrow>
              <IconButton
                size="small"
                onClick={() => showEditNote(review)}
                sx={{ flexShrink: 0 }}
              >
                <Edit sx={{ fontSize: 16 }} />
              </IconButton>
            </Tooltip>
          )}
        </Box>

        <Typography
          variant="body2"
          sx={{
            mt: 1,
            whiteSpace: "pre-wrap",
            color: "text.secondary",
            lineHeight: 1.5,
          }}
        >
          {review.Observation}
        </Typography>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 1,
            mt: 1.5,
            pt: 1,
            borderTop: "1px solid",
            borderColor: "divider",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
            {formattedDate && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <AccessTime sx={{ fontSize: 13, color: "text.disabled" }} />
                <Typography variant="caption" color="text.disabled">
                  {review.CreatedBy && `${review.CreatedBy} · `}{formattedDate}
                </Typography>
              </Box>
            )}
          </Box>

          {review.Evidence && (
            <Chip
              icon={<AttachFile sx={{ fontSize: 14 }} />}
              label={`${review.Evidence.Name} (${getEvidenceType(review.Evidence.EvidenceType)})`}
              size="small"
              variant="outlined"
              onClick={() =>
                window.open(
                  `${window.location.href}/evidence/${review.Evidence.Id}/${review.Evidence.EvidenceType}`,
                  "_blank",
                )
              }
              deleteIcon={
                <Tooltip title={localize.view} arrow>
                  <Visibility sx={{ fontSize: 14 }} />
                </Tooltip>
              }
              onDelete={() =>
                window.open(
                  `${window.location.href}/evidence/${review.Evidence.Id}/${review.Evidence.EvidenceType}`,
                  "_blank",
                )
              }
              sx={{
                fontSize: 11,
                height: 26,
                cursor: "pointer",
                "& .MuiChip-icon": { ml: 0.5 },
              }}
            />
          )}
        </Box>
      </Box>
    </Card>
  );
}
